import instance from "./request";


//新增体检数据
export const addExam = (data) => instance.post('/health/add', data)
//修改体检数据
export const editExam = (data) => instance.post('/health/edit', data)
//体检数据详情
export const examInfo = (id) => instance.get('/health/info/' + id)
//高压设置数据请求
export const healthRule = () => instance.get('/health/rule')
// 
export const healthRuleSet = (data) => instance.post('/health/ruleSet',data)
